(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.querySelectorAll('[data-announcement-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        var bar = button.closest('[data-announcement-bar]');
        if (!bar) return;

        (bar.closest('.shopify-section') || bar).hidden = true;

        try {
          sessionStorage.setItem('announcement', 'hide');
        } catch (e) {
          /* Storage unavailable (private mode / blocked) — dismiss still works for this page. */
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-benefit-icons"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-bi.knn-anim-bi-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-benefit-overtime"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-bo.knn-anim-bo-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-collection-footer-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-anim-cfb-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-collection-logo-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Entrance animation — IntersectionObserver
  ---------------------------------------------------------------- */
  var animEls = document.querySelectorAll('.knn-clf .knn-clf-anim-fade-up');

  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            animObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    animEls.forEach(function (el) { animObserver.observe(el); });
  } else {
    animEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------------
     Per-section tab + carousel initialisation
  ---------------------------------------------------------------- */
  document.querySelectorAll('.knn-clf').forEach(function (section) {
    var sectionId    = section.id;
    var filterBtns   = section.querySelectorAll('[data-knn-clf-filter]');
    var panels       = section.querySelectorAll('[data-clf-panel]');
    var headingSets  = section.querySelectorAll('[data-clf-heading]');
    var swiperInstances = {};

    /* ---- Filter tab bar Swiper (freeMode on mobile, justified on desktop) ---- */
    var filterSwiperEl = section.querySelector('[data-knn-clf-filter-swiper]');
    if (filterSwiperEl && typeof Swiper !== 'undefined') {
      var getFilterOffset = function (swiper) {
        if (window.matchMedia('(max-width: 767px)').matches) return 24;
        if (window.matchMedia('(min-width: 1024px)').matches) {
          var slides = swiper.slides;
          var contentWidth = 0;
          slides.forEach(function (slide, index) {
            contentWidth += slide.offsetWidth;
            if (index < slides.length - 1) contentWidth += swiper.params.spaceBetween;
          });
          return Math.max(0, (swiper.width - contentWidth) / 2);
        }
        return 0;
      };
      var filterSwiper = new Swiper(filterSwiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        freeMode: true,
        grabCursor: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        navigation: {
          prevEl: section.querySelector('.knn-clf__filter-prev'),
          nextEl: section.querySelector('.knn-clf__filter-next')
        },
        scrollbar: {
          el: section.querySelector('.knn-clf__filter-scrollbar'),
          draggable: true,
          hide: false
        },
        on: {
          resize: function (swiper) {
            var nextOffset = getFilterOffset(swiper);
            if (nextOffset === swiper.params.slidesOffsetBefore && nextOffset === swiper.params.slidesOffsetAfter) return;
            swiper.params.slidesOffsetBefore = nextOffset;
            swiper.params.slidesOffsetAfter = nextOffset;
            swiper.update();
          },
          init: function (swiper) {
            var initialOffset = getFilterOffset(swiper);
            swiper.params.slidesOffsetBefore = initialOffset;
            swiper.params.slidesOffsetAfter = initialOffset;
            swiper.update();
          }
        },
        breakpoints: {
          1024: {
            spaceBetween: 10,
            freeMode: true,
            grabCursor: true,
          }
        }
      });
    }

    /* ---- Initialise a panel's Swiper (lazy) ---- */
    function initSwiper(panelIndex) {
      if (swiperInstances[panelIndex]) return;
      if (typeof Swiper === 'undefined') return;

      var swiperEl = section.querySelector('[data-knn-clf-swiper="' + panelIndex + '"]');
      if (!swiperEl) return;

      var autoplay      = swiperEl.dataset.autoplay === 'true';
      var autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay, 10) || 4000;
      var pagEl         = section.querySelector('#knn-clf-pag-' + panelIndex + '-' + swiperEl.dataset.sectionId);
      var prevBtn       = swiperEl.querySelector('.knn-clf__nav-btn--prev') || null;
      var nextBtn       = swiperEl.querySelector('.knn-clf__nav-btn--next') || null;

      swiperInstances[panelIndex] = new Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        speed: 600,

        autoplay: autoplay
          ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,

        pagination: pagEl
          ? { el: pagEl, clickable: true }
          : false,

        navigation: prevBtn && nextBtn
          ? { prevEl: prevBtn, nextEl: nextBtn }
          : false,

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
            centeredSlides: false,
            initialSlide: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 35,
            centeredSlides: false,
            initialSlide: 0,
          }
        }
      });
    }

    /* Keep URL-driven selection and clicks on the same rendering path. */
    function selectFilter(btn) {
        var targetIndex = parseInt(btn.dataset.knnClfFilter, 10);
        if (filterSwiper) filterSwiper.slideTo(targetIndex);

        /* Update tab button state */
        filterBtns.forEach(function (b) {
          var isActive = parseInt(b.dataset.knnClfFilter, 10) === targetIndex;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        /* Update heading */
        headingSets.forEach(function (span) {
          var spanIndex = parseInt(span.dataset.clfHeading, 10);
          var isActive  = spanIndex === targetIndex;
          span.classList.toggle('is-active', isActive);
          span.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) {
            span.removeAttribute('hidden');
          } else {
            span.setAttribute('hidden', '');
          }
        });

        /* Show target panel, hide others, init Swiper on first show */
        panels.forEach(function (panel) {
          var panelIndex = parseInt(panel.dataset.clfPanel, 10);
          var isActive   = panelIndex === targetIndex;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
            initSwiper(panelIndex);
            /* Force Swiper to recalculate size after becoming visible */
            if (swiperInstances[panelIndex]) {
              swiperInstances[panelIndex].update();
            }
          } else {
            panel.setAttribute('hidden', '');
          }
        });

    }

    function syncFilterFromUrl() {
      var tag = window.location.hash.replace(/^#/, '');
      if (!tag && section.dataset.collectionHandle === 'bundles') tag = 'bundle';
      if (!tag && section.dataset.collectionHandle === 'best-sellers') tag = 'best-seller';
      try { tag = decodeURIComponent(tag); } catch (e) { /* Invalid URL escape: use raw value. */ }
      tag = tag.trim().toLowerCase();
      var matchingBtn = Array.from(filterBtns).find(function (btn) {
        return (btn.dataset.clfTag || '').trim().toLowerCase() === tag;
      });
      if (!matchingBtn) matchingBtn = filterBtns[0];
      if (matchingBtn) selectFilter(matchingBtn);
    }

    syncFilterFromUrl();
    window.addEventListener('hashchange', syncFilterFromUrl);
    window.addEventListener('popstate', syncFilterFromUrl);
    window.addEventListener('knn:locationchange', syncFilterFromUrl);

    /* ---- Tab click handler ---- */
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectFilter(this);

        /* Sync URL hashtag filter from this tab's tag setting.
           replaceState (not location.hash) avoids adding history entries
           and prevents the browser from scroll-jumping to a matching id. */
        var tag  = (this.dataset.clfTag || '').trim();
        var base = window.location.pathname + window.location.search;
        if (tag) {
          window.history.replaceState(null, '', base + '#' + encodeURIComponent(tag));
        } else {
          window.history.replaceState(null, '', base);
        }
        // replaceState does not emit hashchange. Notify the collection grid
        // directly so tag-driven filters (including Bundles) always refresh.
        window.dispatchEvent(new Event('knn:locationchange'));
      });
    });

  }); /* end .knn-clf.forEach */

  /* ----------------------------------------------------------------
     Purchase type toggle — Subscribe & Save / Buy Once
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-clf-card]').forEach(function (card) {
    var radios   = card.querySelectorAll('.knn-clf-card__radio');
    var priceEl  = card.querySelector('[data-clf-price]');
    var compareEl = card.querySelector('[data-clf-compare]');
    var atcBtn   = card.querySelector('[data-clf-atc]');

    /* Subscribe is pre-checked, so seed the button from the subscribe variant. */
    function applyType(type) {
      var isSub    = type === 'subscribe';
      var price    = isSub ? card.dataset.subPrice     : card.dataset.price;
      var compare  = isSub ? card.dataset.subCompare   : card.dataset.compare;
      var variant  = isSub ? card.dataset.subVariantId : card.dataset.variantId;
      var plan     = isSub ? (card.dataset.subPlan || '') : '';

      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.classList.toggle('knn-clf-card__price-compare--hidden', !compare);
      }
      if (atcBtn && variant) {
        atcBtn.dataset.currentVariant = variant;
        atcBtn.dataset.currentPlan = plan;
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { applyType(this.value); });
    });

    var checked = card.querySelector('.knn-clf-card__radio:checked');
    applyType(checked ? checked.value : 'subscribe');
  });

  /* ----------------------------------------------------------------
     Add to Cart
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-clf-card] [data-clf-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card      = this.closest('[data-knn-clf-card]');
      /* Set by the purchase-type toggle; falls back to the one-time variant. */
      var variantId = parseInt(this.dataset.currentVariant || card.dataset.variantId, 10);
      if (!variantId) return;
      addToCart(variantId, this, this.dataset.currentPlan);
    });
  });

  function addToCart(variantId, btn, planId) {
    var addText     = btn.dataset.addText     || btn.textContent;
    var loadingText = btn.dataset.loadingText || '...';

    btn.disabled    = true;
    btn.textContent = loadingText;

    var item = { id: variantId, quantity: 1 };
    /* Attach the Recharge plan on Subscribe & Save. Omitted when blank — a falsy
       selling_plan makes Shopify reject the add. */
    if (planId) item.selling_plan = parseInt(planId, 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) {
          throw new Error(e.description || 'Could not add item to cart.');
        });
      }
      return r.json();
    })
    .then(function () {
      return fetch('/?sections=cart-drawer');
    })
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      if (sections && sections['cart-drawer']) {
        var parser      = new DOMParser();
        var doc         = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var newDrawer   = doc.querySelector('cart-drawer');
        var existDrawer = document.querySelector('cart-drawer');

        if (existDrawer && newDrawer) {
          existDrawer.innerHTML = newDrawer.innerHTML;
        }

        var newBubble = doc.querySelector('.cart-count-bubble');
        document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
          if (newBubble) {
            bubble.innerHTML = newBubble.innerHTML;
            bubble.removeAttribute('hidden');
          }
        });
      }
      openCartDrawer();
    })
    .catch(function (err) {
      /* eslint-disable no-console */
      console.error('[knn-clf] add to cart error:', err.message);
      window.alert(err.message);
    })
    .finally(function () {
      btn.disabled    = false;
      btn.textContent = addText;
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Prevents duplicate submissions and gives the button a loading state.
     Native validation still runs first, so an invalid form never locks up. */
  document.querySelectorAll('.knn-contact-form__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      var btn = form.querySelector('.knn-contact-form__submit');
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  });

  /* Move focus to the post-back notice so the outcome is announced. */
  document.querySelectorAll('.knn-contact-form__notice').forEach(function (el) {
    el.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-custom-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.knn-cpt__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.knn-cpt__panel'));
    if (!tabs.length) return;

    /* Respect prefers-reduced-motion: stop autoplaying panel videos and expose controls */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.knn-cpt__panel-video[autoplay]').forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
        video.controls = true;
      });
    }

    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.classList.toggle('knn-cpt__tab--active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (panels[i]) panels[i].hidden = !selected;
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          activate(next, true);
        }
      });
    });
  }

  document.querySelectorAll('[data-knn-cpt]').forEach(initTabs);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-knn-cpt]').forEach(initTabs);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-customer-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-cs.knn-anim-cs-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });

  document.querySelectorAll('.knn-cs').forEach(function (section) {
    var dialog = section.querySelector('.knn-cs__video-modal');
    var frame = dialog ? dialog.querySelector('[data-video-frame]') : null;
    var closeButton = dialog ? dialog.querySelector('.knn-cs__video-modal-close') : null;

    if (!dialog || !frame) return;

    var lastTrigger = null;

    function openVideo(trigger) {
      var videoId = trigger.getAttribute('data-youtube-id');
      if (!videoId) return;

      lastTrigger = trigger;

      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0');
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');
      frame.appendChild(iframe);

      dialog.showModal();
    }

    function closeVideo() {
      if (!dialog.open) return;

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        dialog.close();
        return;
      }

      var handled = false;
      function finishClose() {
        if (handled) return;
        handled = true;
        dialog.removeEventListener('animationend', finishClose);
        dialog.classList.remove('knn-cs__video-modal--closing');
        dialog.close();
      }

      dialog.addEventListener('animationend', finishClose);
      dialog.classList.add('knn-cs__video-modal--closing');
      setTimeout(finishClose, 300);
    }

    section.querySelectorAll('.knn-cs__video-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openVideo(trigger);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeVideo);
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeVideo();
      }
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeVideo();
    });

    dialog.addEventListener('close', function () {
      frame.innerHTML = '';
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Entrance animation ── */
  document.querySelectorAll('.knn-faq.knn-anim-faq-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });

  /* ── Accordion ── */
  function openItem(item) {
    var body = item.querySelector('.knn-faq__item-body');
    var btn  = item.querySelector('.knn-faq__item-header');

    body.style.height = body.scrollHeight + 'px';
    btn.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');

    body.addEventListener('transitionend', function onEnd() {
      body.style.height = 'auto';
      body.removeEventListener('transitionend', onEnd);
    }, { once: true });
  }

  function closeItem(item) {
    var body = item.querySelector('.knn-faq__item-body');
    var btn  = item.querySelector('.knn-faq__item-header');

    body.style.height = body.scrollHeight + 'px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        body.style.height = '0px';
      });
    });
    btn.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
  }

  document.querySelectorAll('.knn-faq').forEach(function (section) {
    section.querySelectorAll('.knn-faq__item-header').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.knn-faq__item');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-help-center"] && !Shopify.designMode) return;
  try {
    
  // Search is the only behaviour that needs scripting — opening an article is
  // handled by :target in CSS. The field stays hidden until this runs.
  (function () {
    function initHelpCenter(root) {
      var form = root.querySelector('[data-hc-search]');
      var input = root.querySelector('[data-hc-input]');
      var status = root.querySelector('[data-hc-status]');
      var empty = root.querySelector('[data-hc-empty]');
      var topics = Array.prototype.slice.call(root.querySelectorAll('[data-hc-topic]'));

      if (!form || !input || !topics.length || root.hasAttribute('data-hc-ready')) return;
      root.setAttribute('data-hc-ready', '');

      var groups = topics.map(function (topic) {
        return {
          topic: topic,
          more: topic.querySelector('[data-hc-more]'),
          items: Array.prototype.slice.call(topic.querySelectorAll('[data-hc-row]')).map(function (row) {
            return { row: row, terms: (row.getAttribute('data-hc-terms') || '').toLowerCase() };
          })
        };
      });

      form.hidden = false;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
      });

      function filter() {
        var query = input.value.trim().toLowerCase();
        var searching = query !== '';
        var matches = 0;

        groups.forEach(function (group) {
          var visible = 0;

          group.items.forEach(function (item) {
            var hit = !searching || item.terms.indexOf(query) !== -1;
            item.row.hidden = !hit;
            if (hit) visible++;
          });

          // Overflow rows are inside a collapsed <details>; a search has to be
          // able to reach them, so force it open while filtering.
          if (group.more) group.more.open = searching;

          group.topic.hidden = visible === 0;
          matches += visible;
        });

        if (empty) empty.hidden = !searching || matches > 0;

        if (!status) return;
        if (!searching) {
          status.textContent = '';
        } else if (matches === 1) {
          status.textContent = '1 ' + (status.getAttribute('data-one') || 'result');
        } else {
          status.textContent = matches + ' ' + (status.getAttribute('data-other') || 'results');
        }
      }

      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(filter, 120);
      });

      // Escape clears the field the way a native search control would.
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value !== '') {
          input.value = '';
          filter();
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.knn-help-center').forEach(initHelpCenter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme editor re-renders the section without a page load.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Single-slide hero: IntersectionObserver triggers entrance animation
  ------------------------------------------------------------------ */
  var singleSlides = document.querySelectorAll(
    '.knn-home-hero:not(.knn-home-hero--carousel) .knn-home-hero__slide'
  );

  if (singleSlides.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    singleSlides.forEach(function (slide) {
      observer.observe(slide);
    });
  } else {
    singleSlides.forEach(function (slide) {
      slide.classList.add('is-visible');
    });
  }

  /* ------------------------------------------------------------------
     Carousel: initialise SwiperJS for each hero instance
  ------------------------------------------------------------------ */
  document.querySelectorAll('[data-knn-hero-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var autoplay = el.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 5000;
    var prevBtn = el.querySelector('.knn-home-hero__nav-btn--prev') || null;
    var nextBtn = el.querySelector('.knn-home-hero__nav-btn--next') || null;
    var paginationEl = el.querySelector('.knn-home-hero__pagination') || null;

    new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      navigation: prevBtn && nextBtn
        ? {
            prevEl: prevBtn,
            nextEl: nextBtn,
          }
        : false,
      on: {
        init: function (swiper) {
          var activeSlide = el.querySelector('.swiper-slide-active');
          if (activeSlide) {
            activeSlide.classList.add('is-visible');
          }
        },
        slideChangeTransitionEnd: function (swiper) {
          el.querySelectorAll('.swiper-slide').forEach(function (slide) {
            if (!slide.classList.contains('swiper-slide-active')) {
              slide.classList.remove('is-visible');
            }
          });
          var activeSlide = el.querySelector('.swiper-slide-active');
          if (activeSlide) {
            activeSlide.classList.add('is-visible');
          }
        },
      },
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-image-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-home-image-text.knn-anim-it-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-logos-accreditation"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-home-accreditation.knn-anim-accreditation-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initPress(scope) {
    scope.querySelectorAll('.knn-home-logos--rotating .knn-home-logos__mobile-wrap').forEach(function (wrap) {
      if (wrap.dataset.pressReady) return;
      wrap.dataset.pressReady = 'true';
      var row = wrap.querySelector('.knn-home-logos__wrap-row');
      var items = Array.from(row.children);
      var index = 0;
      if (items.length) items[0].classList.add('is-active');
      if (row.children.length < 2) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var mobile = window.matchMedia('(max-width: 1200px)');
      var fadeTimer;
      function advance() {
        items[index].classList.remove('is-active');
        fadeTimer = setTimeout(function () {
          index = (index + 1) % items.length;
          items[index].classList.add('is-active');
        }, 500);
      }
      function cleanup() { clearInterval(timer); clearTimeout(fadeTimer); }
      var timer = setInterval(function () {
        if (!wrap.isConnected) { cleanup(); return; }
        if (mobile.matches && !reduced.matches && !document.hidden && !wrap.matches(':hover') && !wrap.contains(document.activeElement)) advance();
      }, 3000);
      var section = wrap.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', cleanup, { once: true });
    });
  }
  initPress(document);
  document.addEventListener('shopify:section:load', function (event) { initPress(event.target); });

  document.querySelectorAll('.knn-anim-logos-reveal').forEach(function (inner) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(inner);
    } else {
      inner.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-product-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Entrance animations
  ---------------------------------------------------------------- */
  var animEls = document.querySelectorAll('.knn-home-atc .knn-atc-anim-fade-up');

  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            animObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    animEls.forEach(function (el) { animObserver.observe(el); });
  } else {
    animEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------------
     SwiperJS carousel
     Desktop (≥768px): slidesPerView:'auto', fixed 283.75px slides,
       centeredSlides — partial cards visible on both viewport edges.
     Mobile: slidesPerView:1.15, auto-width with partial next-slide peek.
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-atc-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var autoplay      = el.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 4000;
    var sectionId     = el.dataset.sectionId;
    var section       = el.closest('.knn-home-atc');
    var isRelatedProducts = section && section.classList.contains('knn-home-atc--related-products');
    var isShopNow = section && section.classList.contains('knn-home-atc--shop-now');

    function sizeShopNowSlides() {
      if (!isShopNow) return;
      var viewport = window.innerWidth;
      var gap = viewport >= 1440 ? 32 : viewport >= 1200 ? 18 : viewport >= 990 ? 28 : 24;
      var styles = getComputedStyle(el);
      var width = el.clientWidth - (parseFloat(styles.paddingLeft) || 0) - (parseFloat(styles.paddingRight) || 0);
      var slideWidth;
      if (viewport >= 990) {
        slideWidth = (width - gap * 3) / 4;
      } else if (viewport >= 768) {
        slideWidth = Math.min((width - gap) / 2, 360);
      } else {
        slideWidth = Math.min(width - 16, 294);
      }
      el.style.setProperty('--knn-home-slide-width', Math.max(240, slideWidth) + 'px');
    }
    sizeShopNowSlides();

    var paginationEl = el.querySelector('.knn-home-atc__pagination') || null;

    var prevBtn = el.querySelector('.knn-home-atc__nav-btn--prev') || null;
    var nextBtn = el.querySelector('.knn-home-atc__nav-btn--next') || null;

    new Swiper(el, {
      on: { beforeResize: sizeShopNowSlides },
      slidesPerView: isShopNow ? 'auto' : 1.08,
      slidesPerGroup: 1,
      spaceBetween: 16,
      loop: false,
      rewind: false,
      centerInsufficientSlides: isRelatedProducts,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,

      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,

      navigation: prevBtn && nextBtn
        ? {
            prevEl: prevBtn,
            nextEl: nextBtn
          }
        : false,

      breakpoints: {
        768: {
          slidesPerView: isShopNow ? 'auto' : 2,
          slidesPerGroup: 1,
          spaceBetween: 24
        },
        990: {
          slidesPerView: isShopNow ? 'auto' : 3,
          slidesPerGroup: 1,
          spaceBetween: 28
        },
        1200: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 18
        },
        1440: {
          slidesPerView: isShopNow ? 'auto' : 4,
          slidesPerGroup: 1,
          spaceBetween: 32
        }
      }
    });
  });

  /* Purchase-type toggle + Add to Cart live in snippets/knn-product-card.liquid. */

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Entrance animations — IntersectionObserver
  ---------------------------------------------------------------- */
  var animEls = document.querySelectorAll('.knn-home-products .knn-products-anim-fade-up');

  if ('IntersectionObserver' in window) {
    var animObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            animObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    animEls.forEach(function (el) { animObserver.observe(el); });
  } else {
    animEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------------
     SwiperJS carousel
     Desktop (≥768px): slidesPerView:'auto', fixed 353px slides,
       centeredSlides — at 1440px viewport this puts the first full card
       at ~160px from the left, matching the Figma content grid.
     Mobile: compact 150–180px cards, with the next slide peeking into view.
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-products-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var autoplay      = el.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 4000;
    var sectionId     = el.dataset.sectionId;
    var section       = el.closest('.knn-home-products');

    var paginationEl = section
      ? section.querySelector('#knn-products-pagination-' + sectionId)
      : null;

    var prevBtn = el.querySelector('.knn-home-products__nav-btn--prev') || null;
    var nextBtn = el.querySelector('.knn-home-products__nav-btn--next') || null;

    new Swiper(el, {
      /* Mobile defaults */
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      loop: true,
      speed: 600,

      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,

      navigation: prevBtn && nextBtn
        ? { prevEl: prevBtn, nextEl: nextBtn }
        : false,

      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-home-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Entrance animation ── */
  document.querySelectorAll('.knn-home-testimonials.knn-anim-testimonials-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });

  /* ── SwiperJS carousel ── */
  document.querySelectorAll('[data-knn-testimonials-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var autoplay =
      el.dataset.autoplay === 'true';

    var autoplayDelay =
      parseInt(el.dataset.autoplayDelay, 10) || 5000;

    var prevBtn =
      el.querySelector(
        '.knn-home-testimonials__nav-btn--prev'
      ) || null;

    var nextBtn =
      el.querySelector(
        '.knn-home-testimonials__nav-btn--next'
      ) || null;

    var paginationEl =
      el.querySelector(
        '.knn-home-testimonials__pagination'
      ) || null;

    /*
    * KNN:
    * Hide navigation/pagination whenever every testimonial
    * fits completely in the current viewport.
    *
    * Example:
    * 4 testimonials + slidesPerView 4
    * = no arrows, no pagination, no dragging.
    *
    * 4 testimonials + slidesPerView 3.15
    * = controls enabled because there is content left to reveal.
    */
    function syncCarouselState(swiper) {
      if (!swiper) return;

      var slidesPerView =
        parseFloat(swiper.params.slidesPerView);

      /*
      * Fallback for unexpected "auto" configurations.
      */
      if (!isFinite(slidesPerView)) {
        slidesPerView = 1;
      }

      var totalSlides =
        swiper.slides.length;

      var hasOverflow =
        totalSlides > slidesPerView + 0.001;

      el.classList.toggle(
        'knn-testimonials--no-overflow',
        !hasOverflow
      );

      /*
      * Do not allow pointless swiping when every card
      * is already visible.
      */
      swiper.allowTouchMove = hasOverflow;

      if (prevBtn) {
        prevBtn.tabIndex = hasOverflow ? 0 : -1;
        prevBtn.setAttribute(
          'aria-hidden',
          hasOverflow ? 'false' : 'true'
        );
      }

      if (nextBtn) {
        nextBtn.tabIndex = hasOverflow ? 0 : -1;
        nextBtn.setAttribute(
          'aria-hidden',
          hasOverflow ? 'false' : 'true'
        );
      }
    }

    var totalSlides = el.querySelectorAll(
      '.knn-home-testimonials__slide'
    ).length;

    function fitSlides(target) {
      return Math.min(totalSlides, target);
    }

    var swiper = new Swiper(el, {
      /*
      * MOBILE
      *
      * Deliberately smaller than one full card so:
      * - card does not feel gigantic;
      * - the next testimonial peeks in;
      * - carousel behavior is immediately obvious.
      */
      slidesPerView: 1.12,
      slidesPerGroup: 1,
      spaceBetween: 14,

      /*
      * Creates breathing room without changing the width
      * of the full-width carousel itself.
      */
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,

      loop: false,
      rewind: false,

      speed: 600,
      grabCursor: true,

      /*
      * Native Swiper protection as well.
      */
      watchOverflow: true,

      breakpoints: {
        /*
        * Tablet:
        * Keep the carousel behavior with a peek of the next card.
        * If there are fewer than 2.15 testimonials, fit whatever exists.
        */
        768: {
          slidesPerView: fitSlides(2.15),
          spaceBetween: 20,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24
        },

        /*
        * Small / medium desktop:
        *
        * - 4+ testimonials → 3.15 visible, next card peeks in.
        * - 3 testimonials  → exactly 3 visible, filling the entire width.
        */
        990: {
          slidesPerView: fitSlides(3.15),
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },

        /*
        * Large desktop:
        *
        * - 4+ testimonials → maximum 4 visible.
        * - 3 testimonials  → exactly 3 visible.
        * - 2 testimonials  → exactly 2 visible.
        *
        * No empty artificial columns.
        */
        1280: {
          slidesPerView: fitSlides(4),
          spaceBetween: 24,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      },

      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,

      navigation:
        prevBtn && nextBtn
          ? {
              prevEl: prevBtn,
              nextEl: nextBtn
            }
          : false,

      on: {
        init: function (swiperInstance) {
          syncCarouselState(swiperInstance);
        },

        resize: function (swiperInstance) {
          syncCarouselState(swiperInstance);
        },

        breakpoint: function (swiperInstance) {
          /*
          * Swiper recalculates params during the breakpoint,
          * so run once in the following frame.
          */
          requestAnimationFrame(function () {
            syncCarouselState(swiperInstance);
          });
        },

        update: function (swiperInstance) {
          syncCarouselState(swiperInstance);
        }
      }
    });

    /*
    * Extra initial sync for safety across Swiper versions.
    */
    requestAnimationFrame(function () {
      syncCarouselState(swiper);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-icon-with-background"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-iwb.knn-anim-iwb-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-img-middle-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-imt.knn-anim-imt-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-page-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* On mobile the active tab can sit off-screen in the scroll strip — bring it
     into view without scrolling the page itself. */
  document.querySelectorAll('.knn-page-tabs').forEach(function (root) {
    var list = root.querySelector('.knn-page-tabs__list');
    var active = root.querySelector('.knn-page-tabs__item--active');
    if (!list || !active) return;
    if (list.scrollWidth <= list.clientWidth) return;

    var target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFaq(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.knn-faq__trigger'));
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.classList.remove('knn-faq__panel--open');
          /* Wait for the collapse transition before hiding from the a11y tree */
          var onEnd = function (event) {
            if (event.propertyName !== 'grid-template-rows') return;
            panel.hidden = true;
            panel.removeEventListener('transitionend', onEnd);
          };
          panel.addEventListener('transitionend', onEnd);
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            panel.hidden = true;
          }
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          /* Force a frame so the 0fr -> 1fr change transitions */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              panel.classList.add('knn-faq__panel--open');
            });
          });
        }
      });
    });
  }

  document.querySelectorAll('[data-knn-faq]').forEach(initFaq);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-knn-faq]').forEach(initFaq);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-product-testimonial"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Entrance animation ── */
  document.querySelectorAll('.knn-pt.knn-anim-pt-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });

  /* ── SwiperJS — desktop only ── */
  document.querySelectorAll('[data-knn-pt-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var autoplay      = el.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 5000;
    var sectionId     = el.dataset.sectionId;
    var section       = el.closest('.knn-pt');

    var paginationEl = section
      ? section.querySelector('#knn-pt-pagination-' + sectionId)
      : null;

    var prevBtn = el.querySelector('.knn-pt__nav-btn--prev') || null;
    var nextBtn = el.querySelector('.knn-pt__nav-btn--next') || null;

    new Swiper(el, {
      /* Disabled on mobile — cards render as flex column via CSS */
      enabled: false,

      autoplay: autoplay
        ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,

      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,

      navigation: prevBtn && nextBtn
        ? { prevEl: prevBtn, nextEl: nextBtn }
        : false,

      breakpoints: {
        768: {
          enabled: true,
          slidesPerView: 'auto',
          spaceBetween: 24,
          centeredSlides: false,
          loop: true,
          speed: 600,
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-review-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     SwiperJS carousel
     Slides-per-view is merchant-controlled via section settings:
     mobile (<768px) 1-3, desktop (>=768px) 3-6.
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-review-swiper]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;

    var slidesDesktop = parseInt(el.dataset.slidesDesktop, 10) || 3;
    var slidesMobile  = parseInt(el.dataset.slidesMobile, 10) || 1;
    var autoplay      = el.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 4000;
    var sectionId     = el.dataset.sectionId;
    var section       = el.closest('.knn-review-slider');

    var paginationEl = section
      ? section.querySelector('#knn-review-pagination-' + sectionId)
      : null;

    var prevBtn = el.querySelector('.knn-review-slider__nav-btn--prev') || null;
    var nextBtn = el.querySelector('.knn-review-slider__nav-btn--next') || null;

    new Swiper(el, {
      /* Mobile defaults */
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      speed: 600,

      autoplay: autoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,

      navigation: prevBtn && nextBtn
        ? { prevEl: prevBtn, nextEl: nextBtn }
        : false,

      breakpoints: {
        1024: {
          slidesPerView: slidesDesktop
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knn-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.knn-rv.knn-anim-rv-reveal').forEach(function (section) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
